import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import GoBack from 'js/containers/GoBack.js';
import { Typography } from '@mui/material';

import faleConosco from 'styles/assets/HelpPages/fale-conosco.png';
import email from 'styles/assets/HelpPages/email.png';

import { trackEventMatomoVisit } from 'js/library/utils/helpers.js';

export default function TalkWithUs() {

  useEffect(() => {
    document.title = 'Fale conosco';
    trackEventMatomoVisit('FaleConosco');
  });

  const { t } = useTranslation();

  return (
    <div>
      <GoBack />

      <div style={{ textAlign: 'center' }}>
        {/* TROCAR */}
        <Typography
          variant="h6"
          style={{ fontWeight: 'bolder', color: '#707070' }}
        >
          {t('contact_us.contact_us')}
        </Typography>

        <img
          src={faleConosco}
          width="70%"
          style={{ paddingTop: '30px' }}
          alt="fale conosco"
        />

        <img
          src={email}
          width="70%"
          style={{ paddingTop: '30px' }}
          alt="email"
        />

        {/* TROCAR */}
        <Typography
          variant="h6"
          style={{
            fontWeight: 'bolder',
            color: '#707070',
            paddingTop: '30px',
          }}
          gutterBottom
        >
          {t('contact_us.opening_hours')}
        </Typography>
        <Typography
          variant="h5"
          style={{ fontWeight: 'bolder', color: '#3DBCEB' }}
        >
          {t('contact_us.hours')}
        </Typography>
      </div>
    </div>
  );
}
